'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.syncObjectKeys = syncObjectKeys;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @callback syncObjectKeys~getter
 * @param {string} key - The key that should be fetched
 * @returns {*|Promise} - Either a direct value or a promise that resolves to the
 *                        correct value
 */

/**
 * @description Syncs the object keys with the given keys.
 * @summary
 * The first argument is the object, that is the subject of this method.
 * The second argument is an array of strings that contain the keys, that should exist in the given object.
 * This method will remove all keys from the object that are not in the keys array.
 * It will also fetch new values for the ones that are in the array using the getter callback.
 * The getter callback will be called with the key as argument and may return a value itself or a Promise that is
 * resolved to a value at some point.
 *
 * This method returns a Promise, that resolves with the new Object.
 *
 * @example
 * import { syncObjectKeys } from '@nimius/object-utility'
 * const data = { a: 'value_a' }
 * const getter = key => `value_${key}`
 *
 * // - Property `a` is removed
 * // - Property `b` is passed to the getter
 * syncObjectKeys(data, ['b'], getter).then(d => console.log(d));
 * // => { b: 'value_b' }
 *
 * @example
 * import { syncObjectKeys } from '@nimius/object-utility'
 * const data = { a: 'value_a' }
 * const getter = key => `value_${key}`
 *
 * // - The changes are not written into `data` and the returned object is
 * //   a new object.
 * syncObjectKeys(data, ['b'], getter, true).then(d => {
 *    console.log(d);
 *    // => { b: 'value_b' }
 *    console.log(data);
 *    // => { a: 'value_a' }
 * });
 *
 * @example
 * import { syncObjectKeys } from '@nimius/object-utility'
 * const data = { a: 'value_a' }
 * const getter = key => fetchDataFromServer(key)
 *
 *
 * // The getter returns a promise that is used to fill the data
 * // the returned promise is resolved when the object is saturated
 * syncObjectKeys(data, ['b'], getter).then(d => console.log(d));
 *
 * @param {Object} object - Object taht is being modified
 * @param {string[]} keys - The keys that should exist in the object.
 *        If this array contains a key that does not exist in the object, then
 *        it is fetched using the getter.
 *        If the object contains keys that is not in the array, then those keys
 *        are removed.
 * @param {syncObjectKeys~getter} getter - The method that is used to fetch new
 *        Object values if they are missing. This method receives the name of
 *        the key and returns the value that should be inserted.
 *        If the returned value is a Promise, then the promise is resolved and
 *        the object is saturated with the resolved data.
 * @param clone - Set to true, if the object should be cloned before applying
          changes.
 * @returns {Promise}
 */
function syncObjectKeys(object, keys, getter) {
    var clone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    // Clone the object, if it was requested
    object = clone ? JSON.parse((0, _stringify2.default)(object)) : object;

    // Keys that are not in the new keys array are deleted
    (0, _keys2.default)(object).filter(function (k) {
        return keys.indexOf(k) === -1;
    }).forEach(function (keyToDelete) {
        return delete object[keyToDelete];
    });

    // Keys that are not yet in the object must be fetched
    var objectKeys = (0, _keys2.default)(object);
    var promises = [];
    keys.filter(function (k) {
        return objectKeys.indexOf(k) === -1;
    }).forEach(function (keyToAdd) {
        var value = getter(keyToAdd);

        // Wait for promise to resolve or write directly to object.
        if (value instanceof _promise2.default || value.then && typeof value.then === 'function') {
            value = value.then(function (v) {
                return object[keyToAdd] = v;
            });
            promises.push(value);
        } else {
            object[keyToAdd] = value;
        }
    });

    return _promise2.default.all(promises).then(function () {
        return object;
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nimius/object-utility/src/sync-object-keys.js
// module id = 94
// module chunks = 0 2